var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeryfrequently(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 22,
    viewBox: "0 0 42 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 16.8954 0.895431 16 2 16H4C5.10457 16 6 16.8954 6 18V20C6 21.1046 5.10457 22 4 22H2C0.89543 22 0 21.1046 0 20V18Z",
    fill: "#00BD7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14C9 12.8954 9.89543 12 11 12H13C14.1046 12 15 12.8954 15 14V20C15 21.1046 14.1046 22 13 22H11C9.89543 22 9 21.1046 9 20V14Z",
    fill: "#7CC79A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C18 8.89543 18.8954 8 20 8H22C23.1046 8 24 8.89543 24 10V20C24 21.1046 23.1046 22 22 22H20C18.8954 22 18 21.1046 18 20V10Z",
    fill: "#F5B63E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 6C27 4.89543 27.8954 4 29 4H31C32.1046 4 33 4.89543 33 6V20C33 21.1046 32.1046 22 31 22H29C27.8954 22 27 21.1046 27 20V6Z",
    fill: "#F28C4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 2C36 0.89543 36.8954 0 38 0H40C41.1046 0 42 0.895431 42 2V20C42 21.1046 41.1046 22 40 22H38C36.8954 22 36 21.1046 36 20V2Z",
    fill: "#E86A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryfrequently);
export default __webpack_public_path__ + "static/media/very frequently.2a2b0947e3be9db78ec8e13875e76119.svg";
export { ForwardRef as ReactComponent };